export default "__VITE_ASSET__84bcd52d__"